module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/voce-sa-f86a3454e41b251571db1a7533a5f40e.webp";